module.exports = __webpack_public_path__ + "img/12.6992901b.svg";